import styled from 'styled-components';
import MenuItem from '../MenuItem/MenuItem.styled';

export const DropdownArea = styled.div``;

export const Chevron = styled.div`
  display: flex;
  align-items: center;
  font-size: 1.25rem;
  transition: transform 100ms;
`;

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  ${MenuItem} {
    height: calc(100% - 1rem);
  }

  ${DropdownArea} {
    display: none;
    background-color: ${({ theme }) => theme.menuDropdownBg};
    border-bottom: 5px solid ${({ theme }) => theme.primary};
    border-radius: 0 0 10px 10px;
    position: absolute;
    top: 100%;
    left: 0.5rem;
    padding: 0.5rem 3rem 0.5rem 0.5rem;
    z-index: 1000;

    ${MenuItem} {
      color: ${({ theme }) => theme.menuDropdownText};

      &::after {
        display: none;
      }

      &:hover {
        color: ${({ theme }) => theme.menuDropdownTextHover};
      }

      &.active {
        color: ${({ theme }) => theme.menuDropdownTextActive};
      }
    }
  }

  &:hover {
    ${Chevron} {
      transform: rotate(90deg);
    }
    ${DropdownArea} {
      display: block;
    }
  }
`;
